import { render, staticRenderFns } from "./ed-confirm-message.component.vue?vue&type=template&id=608547a7&scoped=true&"
import script from "./ed-confirm-message.component.ts?vue&type=script&lang=ts&"
export * from "./ed-confirm-message.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-confirm-message.component.scss?vue&type=style&index=0&id=608547a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608547a7",
  null
  
)

export default component.exports